import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import { getEmployeeBySearchApi } from "../../apiservice/hrpayroll";

export const fetchSalaryPaymentReport = createAsyncThunk(
  "salaryPaymentReport/fetch",
  async (
    { selectedFilterType, selectedRecordType, filters },
    { rejectWithValue }
  ) => {
    try {
      let url = "";

        // EXACT OLD UI MATCH
        if (selectedFilterType === "By Employee" || selectedFilterType === "By Type") {
          url = "/hrpayroll/get-salary-report-details";
        }
        else if (selectedRecordType === "with details") {
          url = "/hrpayroll/get-salary-payment-with-details";
        }
        else {
          url = "/hrpayroll/get-salary-payment-record";
        }

      const payload = {
        selectedFilterType: selectedFilterType || null,

        employeeId:
          selectedFilterType === "By Employee" ? filters.employeeId : null,

        typeId:
          selectedFilterType === "By Type" ||
          selectedFilterType === "By Employee"
            ? filters.typeId === "Monthly Salary"
              ? "Monthly Payment"
              : filters.typeId
            : null,


        userId:
          selectedFilterType === "By User" ? filters.userId : null,

        fromDate: filters.fromDate,
        toDate: filters.toDate,
      };


      const res = await postData(url, payload);

      let mapped = [];

      if (selectedRecordType === "with details") {
        mapped = res.data.map((tr) => ({
          id: tr.pay_code,
          vch_no: tr.pay_code,
          date: tr.created_date,
          acc_name: tr.acc_name,
          month: `${tr.month} ${tr.year}`,
          user: tr.full_name,
          subtotal: Number(tr.total_amount || 0),

          // child rows
          details: tr.details.map((d, idx) => ({
            id: tr.pay_code + "-" + idx,
            employee: d.acc_name,
            pay_type:
            d.pay_type === "Monthly Payment"
              ? "Monthly Salary"
              : d.pay_type,
            amount: Number(d.pay_amount || 0),
          })),
        }));

      } else if (selectedFilterType === "By Employee" || selectedFilterType === "By Type") {
  
        // group by VCH
        const grouped = {};
        res.data.forEach(row => {
          if (!grouped[row.pay_code]) {
            grouped[row.pay_code] = {
              id: row.pay_code,
              vch_no: row.pay_code,
              date: row.created_date,
              acc_name: row.acc_name,
              month: `${row.month} ${row.year}`,
              user: row.full_name,
              subtotal: 0,
              details: []
            };
          }

          grouped[row.pay_code].details.push({
            employee: row.employee_name,
            pay_type:
            row.pay_type === "Monthly Payment"
              ? "Monthly Salary"
              : row.pay_type,
            amount: Number(row.pay_amount || 0)
          });

          grouped[row.pay_code].subtotal += Number(row.pay_amount || 0);
        });

        mapped = Object.values(grouped);
      }
      else {
        mapped = res.data.map((row, idx) => ({
          id: row.pay_code + "-" + idx,
          vch_no: row.pay_code,
          date: row.created_date,
          acc_name: row.acc_name,
          month: `${row.month} ${row.year}`,
          user: row.full_name,
          total: Number(row.pay_total || 0).toFixed(2),
        }));
      }

      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchReportEmployees = createAsyncThunk(
  "salaryPaymentReport/fetchEmployees",
  async ({ query }, { getState, rejectWithValue }) => {
    try {
      const res = await getEmployeeBySearchApi({ query: query?.trim() || "" });

      const state = getState();
      const authInfo = state.auth.auth_info;

      const accountantRoles = [
        "ForthERP_Basic_admin",
        "ForthERP_Standard_admin",
        "ForthERP_Pro_admin",
        "PharmaERP_Basic_admin",
        "PharmaERP_Standard_admin",
        "PharmaERP_Pro_admin",
        "PharmaBooks_Basic_admin",
        "PharmaBooks_Standard_admin",
        "PharmaBooks_Pro_admin",
        "ForthBooks_Basic_admin",
        "ForthBooks_Standard_admin",
        "ForthBooks_Pro_admin",
        "HRPayroll_Standard_admin",
        "HRPayroll_Pro_admin",
        "SuperERP_admin",
        "ForthERP_Basic_accountant",
        "ForthERP_Standard_accountant",
        "ForthERP_Pro_accountant",
        "PharmaERP_Basic_accountant",
        "PharmaERP_Standard_accountant",
        "PharmaERP_Pro_accountant",
        "PharmaBooks_Basic_accountant",
        "PharmaBooks_Standard_accountant",
        "PharmaBooks_Pro_accountant",
        "ForthBooks_Basic_accountant",
        "ForthBooks_Standard_accountant",
        "ForthBooks_Pro_accountant",
      ];

      const userRoles = authInfo?.userInfo?.user_role_names
        ? authInfo.userInfo.user_role_names.split(",").map((r) => r.trim())
        : [];

      const isAccountant = userRoles.some((role) =>
        accountantRoles.includes(role)
      );

      let employees = res.data;
      if (!isAccountant) {
        employees = employees.filter((emp) => emp.hide_salary_details !== 1);
      }

      return employees;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
